/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Modifications copyright (C) 2023 TechnoMindCorp. / Y.K.
 */

import { ReactNode } from 'react'
import { ToolbarDropDown } from './toolbarDropDown'
import ColorPicker from './colorPicker'

interface ColorPickerProps {
  disabled?: boolean
  buttonAriaLabel?: string
  icon?: ReactNode
  buttonLabel?: string
  color: string
  children?: ReactNode
  onChange?: (color: string, skipHistoryStack: boolean) => void
  stopCloseOnClickSelf?: boolean
  title?: string
  tooltip?: string
}

export function ToolbarColorPicker({
  color,
  children,
  onChange,
  disabled = false,
  stopCloseOnClickSelf = true,
  ...rest
}: Readonly<ColorPickerProps>): JSX.Element {
  return (
    <ToolbarDropDown
      {...rest}
      disabled={disabled}
      stopCloseOnClickSelf={stopCloseOnClickSelf}
    >
      <ColorPicker color={color} onChange={onChange} />
      {children}
    </ToolbarDropDown>
  )
}
